export const DEMO_ACADEMY_SLUG = 'demo';
